import GLightbox from '../../assets/vendor/glightbox/dist/js/glightbox.js';

Vue.asyncComponent('ak-image', {
    name:'ak-image',
    props: {
        src: {
            type: String,
            required: true
        },
        alt: {
            type: String,
        },
        width: {
            type: String,
        },
        height: {
            type: String,
        },
        maxWidth: {
            type: String,
        },
        maxHeight: {
            type: String,
        },
        objectFit: {
            type: String,
        },
        objectPosition: {
            type: String,
        },
        backgroundColor: {
            type: String,
        },
        enableLightbox: {
            type: Boolean,
        },
        galleryId: {
            type: String,
        }
    },
    computed: {
        /**
         * Light gallery class
         * @return {string}
         */
        lightGalleryClass() {
            return 'lightgallery-' + (this.galleryId ? this.galleryId: this._uid);
        },
        style() {
            const style = {};

            if (this.width) {
                style['--ak-image-width'] = this.width;
            }

            if (this.height) {
                style['--ak-image-height'] = this.height;
            }

            if (this.maxWidth) {
                style['--ak-image-max-width'] = this.maxWidth;
            }

            if (this.maxHeight) {
                style['--ak-image-max-height'] = this.maxHeight;
            }

            if (this.objectFit) {
                style['--ak-image-object-fit'] = this.objectFit;
            }

            if (this.objectPosition) {
                style['--ak-image-object-position'] = this.objectPosition;
            }

            if (this.backgroundColor) {
                style['--ak-image-background-color'] = this.backgroundColor;
            }

            return style;
        }
    },
    mounted() {
        if (this.enableLightbox) {
            new GLightbox({
                selector: '.' + this.lightGalleryClass,
                touchNavigation: true,
            });
        }
    },
}, 'layout/ak-image.html');